<template>
  <module-list-layout
      :createAction="false"
      :headerActionClass="(userUsingPrivateRate)? 'voip-call-test-status pending p-2 border-0' : 'voip-call-test-status awaiting-action p-2 border-0' "
      :headerActionText="(userUsingPrivateRate)? 'Create Private Rate' : 'Create Default Rate'"
      :headerActionTranslate="false"
      :module="module"
      :title=" customerDisplayName + ' Reseller Rates ' + userRateStatus"
      class="p-2 border-0"
      headerActionType="info"
      style="box-shadow: none" v-if="amReady">

    <el-dialog :append-to-body="true" :visible.sync="dialogVisible" @close="reloadList" title="" top="5vh" width="75%">
      <moduleForm
          :bindingForView="true"
          :resellerUserId="resellerUserId"
          :dataToBind="dataToBind"
          :edit-mode="editMode"
          :formHeader="true"
          :formTitle="'Add Rate to ' + customerDisplayName"
          :moduleDeleteAction='moduleFormDeleteAction'
          :on-create-callback="afterCreate"
          :on-edit-callback="afterEdit"
          :profilesList="profilesList"
          :userUsingPrivateRate="userUsingPrivateRate == 1"
          v-if="dialogVisible"></moduleForm>

      <uploadDocumentRate :customerDisplayName="customerDisplayName" :resellerUserId="resellerUserId" :editMode="false"
                          :userUsingPrivateRate="userUsingPrivateRate == 1"
                          v-if="!editMode"></uploadDocumentRate>
    </el-dialog>


    <div class="row pl-3 pr-3">
      <div class="col-12 col-md-4">
        <dg-text-field
            :field_span="22"
            :label_span="22"
            :liveUpdate="true"
            @amUpdated="userSearchUpdated"
            field_mark=""
            placeholder="search destination"></dg-text-field>
      </div>
      <div class="col-12 col-md-4 pt-3">
        <pagination
            :currentPage="currentPage"
            :navigateHandler="navigateToPage"
            :page-count="getPagesCount()"
            paginateClass=""></pagination>
      </div>
      <div class="col-12 col-md-3 pt-3 text-left">
        <dg-confirm-button
            icon=""
            :loading="false"
            :onConfirm="activateAllNewRates"
            text="Activate All New Rates"
            :translate="false"
            type="success mt-1"
            fieldSize="mini"></dg-confirm-button>
      </div>
    </div>

    <app-ag-grid :agGrid="agGrid"></app-ag-grid>
  </module-list-layout>
</template>

<script>

import actionsCell from './ag-grid/ActionsCell'
import isRateActive from './ag-grid/IsRateActive.vue'
import RateCell from './ag-grid/RateCell.vue'
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'

import isFixedRate from "@/modules/voip-customer-rate/list/page/ag-grid/IsFixedRate";

export default {
  components: {
    uploadDocumentRate: () => import('./../../upload-document-rate/View'),
    pagination: () => import('@/components/pagination/View.vue'),
    moduleForm: () => import('../../form/View'),
    moduleListLayout: () => import('@/modules-config/layouts/list/View.vue')
  },
  props: {
    showOnlyNewRates: {
      required: true
    },
    showOnlyFixedRates: {
      required: true
    },
    resellerUserId: {
      required: true
    },
    customerDisplayName: {
      required: true
    },
    userRateStatus: {
      required: true
    },
    userUsingPrivateRate: {
      required: true
    }
  },
  data() {
    return {
      userSearch: '',
      userSearchTimeOut: null,
      amReady: true,
      module: {
        ...module
      },
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            params.api.sizeColumnsToFit()
          }
        },
        columnDefs: [
          {
            field: 'vendor',
            headerName: 'Vendor',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'division',
            width: 150,
            headerName: 'Division',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'destination',
            headerName: 'Destination',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'rate',
            headerName: 'Rate',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true,
            cellRendererFramework: $vue.extend(RateCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          },
          {
            field: 'isActive',
            width: 110,
            headerName: 'Active',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true,
            cellRendererFramework: $vue.extend(isRateActive),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          },
          {
            field: 'is_fixed',
            width: 110,
            headerName: 'Fixed',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true,
            cellRendererFramework: $vue.extend(isFixedRate),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          },
          {
            width: 110,
            headerName: this.$ml.get('actions'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: $vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }
        ],
        rowData: []
      }
    };
  },
  beforeMount() {
    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)
  },
  methods: {
    activateAllNewRates () {
      this.activateAllNewRatesAction({resellerUserId: this.resellerUserId}).then( r => {
        this.reloadList()
      })
    },
    reloadList() {
      this.getEntityListData(1)
    },
    ...$mapActions('voip-reseller-rate-api', {
      updateResellerRate: 'update',
      activateAllNewRatesAction: 'activateAllNewRates'
    }),
    setIsRateActive(params) {
      let data = {
        is_active: (params.value == true) ? 1 : 0,
      }
      this.updateResellerRate({data, id: params.id})
    },
    setIsFixedRate(params) {
      let data = {
        is_fixed: (params.value == true) ? 1 : 0,
      }
      this.updateResellerRate({data, id: params.id})
    },
    getEntityListData(page) {
      let data = {
        page: page,
        search: this.userSearch,
        only_new_rates: this.showOnlyNewRates,
        only_fixed_rates: this.showOnlyFixedRates,
      }
      if (this.userUsingPrivateRate) {
        data.resellerUserId = this.resellerUserId
      }

      this.getEntityList(data).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
      this.agGrid.rowData = response.rows
      this.recordsCounter = response.count
      this.amReady = true
    },
    userSearchUpdated(field) {
      // this.agGrid.gridApi.setQuickFilter(val);
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    ...$mapActions('voip-reseller-rate-api', {getEntityList: 'list'}),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      this.getEntityListData(page)
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    moduleFormDeleteAction() {
      this.removeAction({
        data: this.dataToBind,
        rowIndex: this.rowToEdit
      })
      this.dialogVisible = false;
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'module->voip-reseller-rate->view', params: { id: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
    },
    removeAction(params) {
      console.log('removeAction(params)', params)
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
